module.exports = __webpack_public_path__ + "static/media/gift06_zhChs.d97859e9.png";